import { hasInDepthAnalysis } from '../components/tabs/InDepthTab';

/** The tabs a session shows: report-based tabs appear only once there is a report to show. */
export const sessionTabs = ({ segmentCount, report, hasReport }) => [
  { id: 'transcript', label: 'Transcript', count: segmentCount },
  { id: 'report', label: 'Session report' },
  hasReport && { id: 'speakers', label: 'Speakers' },
  hasInDepthAnalysis(report) && { id: 'analysis', label: 'In-depth analysis' },
  hasReport && { id: 'qa', label: 'Q&A' },
  report.graphUrl && { id: 'graph', label: 'Knowledge graph' },
  { id: 'details', label: 'Details' },
].filter(Boolean);
